<template>
  <v-btn
    color="primary"
    depressed
    small
    v-if="planStatus === 'trialing'"
    @click="completePlan"
    >{{ $t('message.trialPeriodTime.activePlan') }}</v-btn
  >
  <div
    v-else-if="showActionButtonType !== 'none'"
    :class="showActionButtonType === 'twoButtons' ? 'd-flex' : ''"
  >
    <base-btn
      v-if="showActionButtonType === 'twoButtons'"
      class="mr-3"
      type="secondary"
      size="small"
      :disabled="loadings.tryingAgain"
      :loading="loadings.tryingAgain"
      @click="tryAgain"
    >
      {{ $t('message.trialPeriodTime.useCreditCard') }}
    </base-btn>
    <base-btn
      v-if="planStatus !== 'trialing'"
      size="small"
      @click="handleResolvePending"
    >
      {{ $t('message.trialPeriodTime.resolvePending') }}
    </base-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ActionButton',
  components: {
    BaseBtn: () => import('@/components/BaseBtn.vue'),
  },
  props: {
    planStatus: {
      required: true,
    },
  },
  data: () => ({
    loadings: {
      tryingAgain: false,
    },
  }),
  methods: {
    handleResolvePending() {
      this.$root.$emit('openWarningPaymentIssue')
    },
    completePlan() {
      this.$root.$emit('ModalResetBillingCycle')
    },
    tryAgain() {
      this.$root.$emit('openWarningPaymentIssue')
    },
  },
  computed: {
    ...mapState('dashboard', {
      showActionButtonType: (state) => state.warnings.showActionButtonType,
    }),
  },
}
</script>
